import React from "react";
import { getMenus } from "./LayoutSideMenu";

const LayoutSideMobileMenu = () => {
	if(getMenus()?.menus && getMenus()?.menus?.length > 0){
	return (
		<div className="mobile-subsidebar is-activity">
			<div className="inner">
				<div className="sidebar-title">
					<h3>{getMenus().name}</h3>
				</div>
				<ul className="submenu">

						{/* Side Menu Starts */}
						{getMenus().menus.map((menu, i) => {
                            if(menu.divider) return <li className="divider" />
							if (menu?.sub?.length > 0) {
								return (
									<li key={i} className={"has-children"}>
										<div className="collapse-wrap">
											<a href="javascript:void(0);" className="parent-link">
												{menu?.name}
												<svg
													xmlns="http://www.w3.org/2000/svg"
													width={24}
													height={24}
													viewBox="0 0 24 24"
													fill="none"
													stroke="currentColor"
													strokeWidth={2}
													strokeLinecap="round"
													strokeLinejoin="round"
													className="feather feather-chevron-right"
												>
													<polyline points="9 18 15 12 9 6" />
												</svg>
											</a>
										</div>
										<ul>
											{menu?.sub?.map((sub, k) => {
												return (
													<li>
														<a className="is-submenu" href={sub?.link}>
															<i
																className={
																	sub?.icon || "lnil lnil-chevron-right"
																}
															/>
															<span>{sub?.name}</span>
														</a>
													</li>
												);
											})}
										</ul>
									</li>
								);
							}
							return (
								<li class="is-activex">
									<a href={menu?.link}>{menu?.name}</a>
								</li>
							);
						})}

						
				</ul>
				<div className="bottom-action"></div>
			</div>
		</div>
	);
	}
	return <div/>
};

export default LayoutSideMobileMenu;
